import React, { useState } from 'react';
import { PageHeader, MetricRow, MetricCard, Button, Modal } from '../../components';
import styles from './Team.module.css';

const Team = () => {
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [inviteEmail, setInviteEmail] = useState('');
  const [inviteRole, setInviteRole] = useState('Operations lead');

  const teamMembers = [
    { name: 'Nishant K.', email: 'nishant@nopser.com', role: 'Super admin', isSuper: true, lastActive: 'Now' },
    { name: 'Pooja S.', email: 'pooja@nopser.com', role: 'Operations lead', isSuper: false, lastActive: '1h ago' },
    { name: 'Aakash R.', email: 'aakash@nopser.com', role: 'Operations', isSuper: false, lastActive: '3h ago' },
    { name: 'Megha T.', email: 'megha@nopser.com', role: 'Support lead', isSuper: false, lastActive: '12m ago' },
    { name: 'Vikram B.', email: 'vikram@nopser.com', role: 'Finance / Payouts', isSuper: false, lastActive: 'Yesterday' }
  ];

  const handleInvite = (e) => {
    e.preventDefault();
    alert(`Invite sent to ${inviteEmail} as ${inviteRole}.`);
    setShowInviteModal(false);
    setInviteEmail('');
  };

  return (
    <div className={styles.container}>
      <PageHeader
        title="Admin team"
        subtitle="Team members with access to the operations console."
        actions={
          <Button variant="primary" onClick={() => setShowInviteModal(true)}>
            + Invite admin
          </Button>
        }
      />

      <MetricRow>
        <MetricCard label="Total team" value="6" subtext="all active" />
        <MetricCard label="Roles" value="4" subtext="permission tiers" />
        <MetricCard
          label="2FA enforcement"
          value="100%"
          subtext="hardware / TOTP"
          valueColor="var(--color-success)"
        />
      </MetricRow>

      <section className={styles.tableCard}>
        <div className={styles.tableHeader}>
          <div>Admin</div>
          <div>Email</div>
          <div>Role</div>
          <div>Last active</div>
        </div>

        {teamMembers.map((member, idx) => (
          <div key={idx} className={styles.tableRow}>
            <span className={styles.nameCol}>{member.name}</span>
            <span className={styles.emailCol}>{member.email}</span>
            <span className={member.isSuper ? styles.superRoleCol : styles.roleCol}>
              {member.role}
            </span>
            <span className={styles.lastActiveCol}>{member.lastActive}</span>
          </div>
        ))}
      </section>

      <Modal
        isOpen={showInviteModal}
        onClose={() => setShowInviteModal(false)}
        title="Invite administrator"
        maxWidth={440}
        footer={
          <div className={styles.modalFooter}>
            <Button variant="secondary" onClick={() => setShowInviteModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleInvite}>
              Send invitation
            </Button>
          </div>
        }
      >
        <form onSubmit={handleInvite} className={styles.form}>
          <label className={styles.formGroup}>
            Email address
            <input
              type="email"
              required
              placeholder="colleague@nopser.com"
              value={inviteEmail}
              onChange={(e) => setInviteEmail(e.target.value)}
              className={styles.input}
            />
          </label>

          <label className={styles.formGroup}>
            Role
            <select
              value={inviteRole}
              onChange={(e) => setInviteRole(e.target.value)}
              className={styles.select}
            >
              <option value="Super admin">Super admin</option>
              <option value="Operations lead">Operations lead</option>
              <option value="Operations">Operations</option>
              <option value="Support lead">Support lead</option>
              <option value="Finance">Finance</option>
            </select>
          </label>
        </form>
      </Modal>
    </div>
  );
};

export default Team;
